<div class="status" :class="statusColor"><span>{{text}}</span></div>